import React from 'react';
import Section from '../common/Section';
import styles from '../../styles/modules/common/content.module.scss';
import parse from 'html-react-parser'
import { Hidden } from '@mui/material';
import Image from '../common/Image';

const WhoAreWe = (props) => {
    const { IsSubtitle, heading, paragraph } = props;
    return (
        <Section className={`${styles.who_are_we} whoarewe`} hasPadding={true}>
            <div className="container">
                <div className={`row`}>
                    <div className={IsSubtitle ? `${styles.imagesmall} col-12  col-lg-6` : `${styles.image} col-12  col-lg-6`}>
                        <Hidden mdUp>
                        {IsSubtitle && <p className={`${styles.bluehead}`}>ABOUT</p>}
                        <div><h4 className={IsSubtitle ? styles.headerH : styles.header}>{heading ? heading : "Who Are We?"}</h4></div>

                        </Hidden>
                        <Image src={"/static/images/why-onsitego.svg"|| ''} alt={"Why Onsitego"} width="730" height="516" />
                    </div>
                    <div className={`${styles.textcontent} col-12 col-lg-6`}>
                        <Hidden mdDown>
                        {IsSubtitle && <p className={`${styles.bluehead}`}>ABOUT</p>}
                        <div><h4 className={IsSubtitle ? styles.headerH : styles.header}>{heading ? heading : "Who Are We?"}<em className="title-el-cap"></em></h4></div>

                        </Hidden>
                        <h6 className={IsSubtitle ? styles.subtitleH : styles.subtitle}>One-stop Solution for All Your Device Needs:</h6>

                        <p className={`${styles.para4}`}>{paragraph ? parse(paragraph) : "Onsitego is India’s leading device-care provider and offers Extended Warranty, Damage Protection, AMC Plans, and On-Demand Repair Services. We cover all electronic devices and home appliances. Our plans are widely available across retail stores and online marketplaces. "}</p>
                        <Hidden mdDown>
                        <div className={`${styles.infopar}`}>
                            <div className={`${styles.pad}`}>
                                <span className={`${styles.info}`}>10,000</span><span className={`${styles.info__small}`}>+</span>
                                <p className={styles._info_p}>Retail Stores</p>
                            </div >
                            <div  className={`${styles.pad} `}>
                                <span className={`${styles.info}`}>300</span><span className={`${styles.info__small}`}>+</span>
                                <p className={styles._info_p}>Brands Covered</p>
                            </div>
                            <div className={`${styles.pad} `}>
                                <span className={`${styles.info}`}>2.5</span><span className={`${styles.info__small}`}>+</span>
                                <p className={styles._info_p}>Crore Customers</p>
                            </div>
                        </div>
                        </Hidden>
                    </div>
                </div>
            </div>
        </Section>
    );
}



export default WhoAreWe;